import React from 'react';
import Icon from '../../../components/AppIcon';

const CashFlowAnalysis = ({ data }) => {
  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
            Cash Flow Analysis
          </h3>
          <p className="text-sm text-muted-foreground">
            Accounts receivable and payment tracking
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4 mb-6">
        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="DollarSign" size={18} color="var(--color-primary)" />
            <span className="text-sm text-muted-foreground">Accounts Receivable</span>
          </div>
          <div className="text-2xl font-semibold text-foreground data-text">
            ${data?.accountsReceivable?.toLocaleString()}
          </div>
        </div>
        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="AlertTriangle" size={18} color="var(--color-warning)" />
            <span className="text-sm text-muted-foreground">Outstanding Balances</span>
          </div>
          <div className="text-2xl font-semibold text-foreground data-text">
            ${data?.outstandingBalances?.toLocaleString()}
          </div>
        </div>
      </div>
      <div className="bg-error/10 border border-error/20 rounded-lg p-4 mb-6">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <Icon name="XCircle" size={20} color="var(--color-error)" />
            <span className="text-sm font-semibold text-error">Payment Failures</span>
          </div>
          <span className="text-lg font-semibold text-error data-text">{data?.paymentFailures}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-xs text-muted-foreground">Retry Scheduled</span>
          <span className="text-sm font-medium text-foreground data-text">{data?.retryScheduled} transactions</span>
        </div>
      </div>
      <div>
        <h4 className="text-sm font-semibold text-foreground mb-4">Aging Analysis</h4>
        <div className="space-y-3">
          {data?.collections?.map((item, idx) => (
            <div key={idx}>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm text-foreground">{item?.period}</span>
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-foreground data-text">
                    ${item?.amount?.toLocaleString()}
                  </span>
                  <span className="text-xs text-muted-foreground">({item?.percentage}%)</span>
                </div>
              </div>
              <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                <div
                  className={`h-full transition-all duration-500 ${
                    idx === 0 ? 'bg-success' : idx === 1 ? 'bg-primary' : idx === 2 ? 'bg-warning' : 'bg-error'
                  }`}
                  style={{ width: `${item?.percentage}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CashFlowAnalysis;